import { useState, useEffect } from "react";

const NAV_LINKS = [
  { label: "Início", href: "#inicio" },
  { label: "Sobre", href: "#sobre" },
  { label: "Empresas", href: "#empresas" },
  { label: "Pessoa Física", href: "#pessoa-fisica" },
  { label: "Áreas de Atuação", href: "#areas" },
  { label: "Contato", href: "#contato" },
];

const WHATSAPP_URL = "https://wa.me/5512991220961?text=Olá,%20gostaria%20de%20falar%20com%20um%20advogado.";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm border-b border-gray-100" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-20">
        {/* Logo */}
        <a href="#inicio" onClick={() => handleNavClick("#inicio")} className="cursor-pointer flex-shrink-0">
          <h1>
            <img
              src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/6f9e88539aee89d9d9e686aaa7e2f8aa.png"
              alt="SM Advogados Logo"
              className="h-14 w-auto object-contain"
            />
          </h1>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
              className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                scrolled
                  ? "text-grafite hover:text-rose-primary"
                  : "text-white/90 hover:text-white"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="hidden lg:flex items-center gap-2 bg-rose-primary hover:bg-rose-dark text-white text-sm font-medium px-5 py-2.5 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-whatsapp-line text-sm" />
          </div>
          Falar no WhatsApp
        </a>

        {/* Mobile Hamburger */}
        <button
          className={`lg:hidden flex items-center justify-center w-10 h-10 cursor-pointer ${scrolled ? "text-grafite" : "text-white"}`}
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="Menu"
        >
          <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-3 shadow-md">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
              className="text-sm font-medium text-grafite py-2 border-b border-gray-light hover:text-rose-primary transition-colors cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 bg-rose-primary text-white text-sm font-medium px-5 py-3 rounded-full mt-2 cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-whatsapp-line text-sm" />
            </div>
            Falar no WhatsApp
          </a>
        </div>
      )}
    </header>
  );
}
